export default __webpack_public_path__ + "static/media/prospects_white_tr.21d2f97c.svg";